<template>
  <div class="bubly-hamburger_container" :class="{ open: state }">
    <button class="bubly-hamburger" @click='toggle' :aria-expanded="state" :aria-label="state ? 'Close navigation menu' : 'Open navigation menu'">
      <span class="bubly-hamburger_inner"></span>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'hamburger',
    props: {
      state: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      toggle() {
        this.$emit('toggle');
      },
    },
  };
</script>

<style lang='scss' scoped>
  @import './../../variables';

  .open {
    .bubly-hamburger {
      &:hover {
        .bubly-hamburger_inner,
        .bubly-hamburger_inner:before,
        .bubly-hamburger_inner:after {
          background-color: $bubly-white;
        }
      }

      &_inner {
        transition-delay: .12s;
        transition-timing-function: cubic-bezier(.215,.61,.355,1);
        transform: rotate(225deg);
        background-color: $bubly-white;
        border-radius: 4px;
      }

      &_inner:before {
        top: 0;
        transition: top .1s ease-out, opacity .1s ease-out .12s;
        opacity: 0;
        border-radius: 4px;
        background-color: $bubly-white;
      }

      &_inner:after {
        bottom: 0;
        border-radius: 4px;
        transition: bottom .1s ease-out, transform .22s cubic-bezier(.215,.61,.355,1) .12s;
        transform: rotate(-90deg);
        background-color: $bubly-white;
      }
    }
  }

  .bubly-hamburger {
    border: none;
    padding: 0;
    cursor: pointer;
    position: absolute;
    display: block;
    top: 50%;
    right: rem(15);
    height: rem(30);
    width: rem(30);
    transform: translateY(-50%);
    margin-left: auto;
    background-color: transparent;

    &:hover {
      .bubly-hamburger_inner,
      .bubly-hamburger_inner:before,
      .bubly-hamburger_inner:after {
        background-color: $bubly-cyan;
      }
    }

    &_inner,
    &_inner:before,
    &_inner:after {
      width: rem(30);
      height: 4px;
      content: '';
      display: block;
      position: absolute;
      border-radius: 4px;
      background-color: $bubly-blue;
    }

    &_inner {
      transition-timing-function: cubic-bezier(.55,.055,.675,.19);
      transition-duration: .22s;
      transition-property: transform;
      top: 50%;
      display: block;
      margin-top: -2px;

      &:before {
        top: -10px;
        transition: top .1s ease-in .25s, opacity .1s ease-in;
      }

      &:after {
        bottom: -10px;
        transition: bottom .1s ease-in .25s, transform .22s cubic-bezier(.55,.055,.675,.19);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/navigation/Hamburger.vue